import { createAction } from "@logicsoftware/redux-toolkit";
import { put, select, takeLeading } from "redux-saga/effects";
import { LSHelper } from "~/EasyProjectsCommon/LSHelper";
import { MENU_SPACE_KEY } from "../../consts";
import { Space } from "../../types";
import { isSpacesLoaded, spacesList } from "../selectors";
import { loadSpaces } from "./loadSpaces";
import { saveMenuSpace } from "./saveMenuSpace";

/**
 * Loads spaces (if not loaded yet) and sets the current one in the following priority:
 *  - space from URL if it exists
 *  - last opened space (from local storage)
 *  - first space from the list
 */
export const initMenuSpace = createAction<{ urlSpaceId: number }>("SPACES/INIT_MENU_SPACE");

export function* watchInitMenuSpace() {
    yield takeLeading(initMenuSpace, function* (action) {
        const { urlSpaceId } = action.payload;

        const isLoaded: boolean = yield select(isSpacesLoaded);
        if (!isLoaded) {
            yield loadSpaces();
        }

        const spaces: Space[] = yield select(spacesList);

        const lastOpenedSpaceId = LSHelper.getJSON(MENU_SPACE_KEY);
        const space =
            spaces.find(x => x.SpaceId === urlSpaceId) ??
            spaces.find(x => x.SpaceId === lastOpenedSpaceId) ??
            spaces[0];

        yield put(saveMenuSpace(space?.SpaceId ?? null));
    });
}
